var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.74 46.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CSS3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,0l3.61,40.97,16.26,5.4,16.26-5.4L39.74,0H0Zm32.41,8.28l-.5,4.9-11.93,5.1h-.03s11.54.01,11.54.01l-1.32,15.17-10.16,2.97-10.23-3.02-.66-7.65h5.06l.33,3.96,5.44,1.38,5.66-1.59.38-6.38-17.21-.05h0s-.02,0-.02,0l-.37-4.79,11.6-4.83.67-.28H7.94l-.6-4.9h25.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCss3);
export default __webpack_public_path__ + "static/media/icon_css3.8da54c707de3ff50aa38ec2cc7048641.svg";
export { ForwardRef as ReactComponent };